import React from 'react';
import axios from 'axios';
import Loader from '../loader';

const SectionPlans = ({
  companyId,
  crafanId,
  crafansPlans,
  setCrafansPlans,
  isNew
}) => {
  const [isCreating, setIsCreating] = React.useState(false);
  const [editableCrafansPlanIds, setEditableCrafansPlanIds] = React.useState(
    []
  );

  const initialCrafansPlan = {
    id: '',
    crafan_id: crafanId,
    title: 'チケット',
    description: '',
    capacity: null,
    price: 0
  };

  const addCrafansPlan = React.useCallback(() => {
    setIsCreating(true);
    axios
      .post(
        `/api/community/${companyId}/crafans/${crafanId}/crafans_plans`,
        initialCrafansPlan
      )
      .then(response => {
        setCrafansPlans(prev => [...prev, response.data]);
        setEditableCrafansPlanIds(prev => [...prev, response.data.id]);
      })
      .finally(() => {
        setIsCreating(false);
      });
  });

  const removeCrafansPlan = React.useCallback(
    (planId, index) => {
      axios
        .delete(
          `/api/community/${companyId}/crafans/${crafanId}/crafans_plans/${planId}`,
          {
            crafan_id: crafanId,
            id: planId
          }
        )
        .then(() => {
          setCrafansPlans(prev => {
            const newCrafansPlans = [...prev];
            newCrafansPlans.splice(index, 1);
            return newCrafansPlans;
          });
        });
    },
    [crafanId]
  );

  return (
    <section id="plans">
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
          チケット設定
        </p>
      </div>
      <div className={`container col-md-8 col-lg-6`} />
      {crafansPlans.map((crafansPlan, index) => (
        <CrafansPlanBox
          key={crafansPlan.id}
          companyId={companyId}
          crafansPlan={crafansPlan}
          setcrafansPlan={plan => {
            setCrafansPlans(prev => {
              const newCrafansPlans = [...prev];
              newCrafansPlans[index] = plan;
              return newCrafansPlans;
            });
          }}
          removeCrafansPlan={() => {
            removeCrafansPlan(crafansPlan.id, index);
          }}
          isEditable={editableCrafansPlanIds.includes(crafansPlan.id) || isNew}
          isRemovable={crafansPlans.length > 1}
        />
      ))}
      {isCreating ? (
        <Loader isActive={isCreating} />
      ) : (
        <div className="container col-md-8 col-lg-6 p-0">
          <div className="d-flex justify-content-end mr-1">
            <button
              className="bg-white mt-1 border border-dark"
              onClick={() => addCrafansPlan()}
            >
              <p className="text-fz-14px text-black-333 text-fw-normal m-1">
                ＋ チケットの追加
              </p>
            </button>
          </div>
        </div>
      )}
    </section>
  );
};
const CrafansPlanBox = ({
  companyId,
  crafansPlan,
  setcrafansPlan,
  removeCrafansPlan,
  isEditable,
  isRemovable
}) => {
  const onChangeTitle = title => {
    setcrafansPlan({ ...crafansPlan, title });
  };

  const onChangeDescription = description => {
    setcrafansPlan({ ...crafansPlan, description });
  };

  const onChangePrice = price => {
    setcrafansPlan({ ...crafansPlan, price: parseInt(price) });
  };

  const onChangeCapacity = capacity => {
    setcrafansPlan({ ...crafansPlan, capacity: parseInt(capacity) });
  };

  const updateCrafansPlan = () => {
    axios.patch(
      `/api/community/${companyId}/crafans/${
        crafansPlan.crafan_id
      }/crafans_plans/${crafansPlan.id}`,
      crafansPlan
    );
  };

  return (
    <div className="mb-2">
      <div className="shadow-sm mb-0 bg-white">
        <div className="container col-md-8 col-lg-6 p-3_5 border-bottom">
          <div className="row justify-content-between p-1">
            <p className="col-4 pr-2 m-0">チケット名</p>
            <input
              id="title"
              className="col-8 p-0 w-100 textarea--eventreport text-right"
              value={crafansPlan.title}
              onBlur={updateCrafansPlan}
              onChange={e => onChangeTitle(e.target.value)}
              placeholder="チケット名"
            />
          </div>
        </div>
      </div>
      <div className="shadow-sm mb-0 bg-white">
        <div className="container col-md-8 col-lg-6 p-3_5 border-bottom">
          <div className="row justify-content-between p-1">
            <p className="col-4 pr-2 m-0">チケット詳細</p>
            <input
              id="description"
              className="col-8 p-0 w-100 textarea--eventreport text-right"
              value={crafansPlan.description}
              onBlur={updateCrafansPlan}
              onChange={e => onChangeDescription(e.target.value)}
              placeholder="チケット詳細"
            />
          </div>
        </div>
      </div>
      <div className="shadow-sm mb-0 bg-white">
        <div className="container col-md-8 col-lg-6 border-bottom p-3_5">
          <div className="row justify-content-between p-1">
            <p className="col-4 pr-2 m-0">1口価格</p>
            <div className="col-8 d-flex justify-content-end">
              <input
                id="price"
                className="p-0 textarea--eventreport text-right"
                type="number"
                min="0"
                defaultValue={crafansPlan.price}
                onBlur={updateCrafansPlan}
                onChange={e => onChangePrice(e.target.value)}
                placeholder="必須"
                style={{ width: '160px' }}
                disabled={!isEditable}
              />
              <span className="p-0 text-right">円</span>
            </div>
          </div>
        </div>
      </div>
      <div className="shadow-sm mb-0 bg-white">
        <div className="container col-md-8 col-lg-6 border-bottom p-3_5">
          <div className="row justify-content-between p-1">
            <p className="col-4 pr-2 m-0">応募上限</p>
            <div className="col-8 d-flex justify-content-end">
              <input
                id="capacity"
                className="p-0 textarea--eventreport text-right"
                type="number"
                min="0"
                defaultValue={crafansPlan.capacity}
                onBlur={updateCrafansPlan}
                onChange={e => onChangeCapacity(e.target.value)}
                placeholder="必須"
                style={{ width: '160px' }}
                disabled={!isEditable}
              />
              <span className="p-0 text-right">口</span>
            </div>
          </div>
        </div>
      </div>
      <div className="shadow-sm mb-3 bg-white">
        <div className="container col-md-8 col-lg-6 p-3_5">
          <div className="row d-flex justify-space-between">
            <div className="col-7">
              {isRemovable && (
                <button
                  className="bg-white mt-1 w-100 border border-dark"
                  onClick={() => removeCrafansPlan()}
                >
                  <p className="text-fz-14px text-black-333 text-fw-normal m-1">
                    ー チケットの削除
                  </p>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionPlans;
